import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function deleteOrchidProProfileImg() {
  const res = await fetchOrchidAPI("/api/users/orchid_pro/profile_image", {
    method: "DELETE",
  });

  if (!res.ok) {
    throw new Error(
      `failed to delete profile image: ${getErrorDetail(await res.text())}`,
    );
  }

  return;
}
